import axios from "axios";
import { SERVERPATH, objToFormData } from "./index";

const BorrowerPath = `${SERVERPATH}/borrower/`;

export async function borrowerLogin(payload) {
    const response = await axios.post(`${BorrowerPath}login/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerGetProfile() {
    const response = await axios.get(`${BorrowerPath}profile/`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerSignUp(payload) {
    const response = await axios.post(`${BorrowerPath}signup/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerReSend(payload) {
    const response = await axios.post(`${BorrowerPath}signup/confirmation/link/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerVerify(payload) {
    const response = await axios.post(`${BorrowerPath}signup/confirmation/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerProfile() {
    const response = await axios.get(`${BorrowerPath}profile/`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerProfilePatch(payload) {
    const response = await axios.patch(`${BorrowerPath}profile/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerDocuments() {
    const response = await axios.get(`${BorrowerPath}business-documents/`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerUpload(payload) {
    const formData = objToFormData(payload);

    return await axios.post(`${BorrowerPath}business-documents/`, formData);
}

export async function borrowerLogout(payload = {}) {
    const response = await axios.post(`${BorrowerPath}logout/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerForgotPassword(payload) {
    const response = await axios.post(`${BorrowerPath}password/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerUpdatePassword(payload) {
    const response = await axios.post(`${BorrowerPath}password/confirmation/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerAddWishlist(payload) {
    const response = await axios.post(`${BorrowerPath}wishlist/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerGetWishlist() {
    const response = await axios.get(`${BorrowerPath}wishlist/`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerDeleteWishlist(id) {
    const response = await axios.delete(`${BorrowerPath}wishlist/${id}`);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerActivities(filters = {}) {
    const response = await axios.get(`${BorrowerPath}activity/`, {
        params: {
            limit: filters?.limit,
            page: filters?.page,
        },
    });

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerInquiry(payload) {
    const response = await axios.post(`${BorrowerPath}partnership-inquiry/`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    return responseData;
}

export async function borrowerFeedback(payload) {
    const response = await axios.post(`${SERVERPATH}/external/microfeedback`, payload);

    const { status, data: responseData } = response;

    if (status !== 201) {
        throw response;
    }

    return responseData;
}

export async function borrowerGetSMSOTP(params) {
    const response = await axios.get(`${BorrowerPath}sms/otp`, { params });

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}

export async function borrowerVerifySMSOTP(payload) {
    const response = await axios.put(`${BorrowerPath}sms/otp`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}

export async function borrowerSubmitTestimonial(payload) {
    const response = await axios.post(`${BorrowerPath}testimonials`, payload);

    const { status, data: responseData } = response;

    if (status !== 200) {
        throw response;
    }

    const { status: ocStatus, data } = responseData;

    if (ocStatus !== 200) {
        throw responseData;
    }

    return data;
}
